import { Link } from "react-router-dom";

interface NewsListItemProps {
  id: string;
  title: string;
  publishDate: string;
  source: string;
  summary: string;
  cover: string;
}

export default function NewsListItem({ id, title, publishDate, source, summary, cover }: NewsListItemProps) {
  return (
    <Link
      to={`/detail/${id}`}
      className="group flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-100/70 p-3 transition-colors duration-300 hover:border-primary-500/60 sm:flex-row md:p-4"
    >
      <div className="h-44 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-32 sm:w-52">
        <img
          src={cover}
          alt={title}
          title={`${title} - 夜无疆影视资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-price-tag-3-line" />
            {source}
          </span>
        </div>
        <h3 className="mt-2 line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors duration-200 group-hover:text-primary-400 md:text-lg">
          {title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-7 text-foreground-600">{summary}</p>
        <span className="mt-auto pt-3 text-xs font-label text-primary-400">
          阅读全文 <i className="ri-arrow-right-line" />
        </span>
      </div>
    </Link>
  );
}